import gql from 'graphql-tag';
import * as i0 from "@angular/core";
import * as i1 from "../shared/services/graph-qlclient.service";
export class DocumentoTrazaService {
    constructor(gqlclient) {
        this.gqlclient = gqlclient;
    }
    obtenerDocumento(inputParams, callback) {
        this.gqlclient.query({
            query: gql `
          query ($empresa_rut: Decimal, $tipo_dte_codigo: Decimal, $folio: Decimal) {
            documento_traza {
              obtenerDocumento(empresa_rut: $empresa_rut, tipo_dte_codigo: $tipo_dte_codigo, folio: $folio) {
                mensajes {
                  codigo
                  texto
                  tipo
                }
                respuesta {
                  documento {
                    folio
                    fecha_emision
                    rut_emisor
                    nombre_emisor
                    direccion_nombre
                    rut_receptor
                    nombre_receptor
                    monto_total
                  }
                  eventos {
                    fecha_evento
                    evento_nombre
                    observacion
                  }
                }
              }
            }
          }
        `,
            variables: inputParams,
            fetchPolicy: 'no-cache',
        }, function (response) {
            const { mensajes, respuesta } = response.data.documento_traza.obtenerDocumento;
            callback({ mensajes, respuesta });
        });
    }
}
DocumentoTrazaService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function DocumentoTrazaService_Factory() { return new DocumentoTrazaService(i0.ɵɵinject(i1.GraphQLClient)); }, token: DocumentoTrazaService, providedIn: "root" });
